// Phuket wall-clock helpers for pickup times (extracted from CheckoutCard so
// the request-to-book cards send exactly the same shape, 2026-09-09).
//
// A transfer or package pickup is a PHUKET instant, not a browser-local one:
// the driver is dispatched off Asia/Bangkok time whatever timezone the
// customer's phone is in. The Rails app's own Time.zone is UTC, so the client
// must send an explicit +07:00 offset. Asia/Bangkok has no DST, so a fixed
// offset is safe year-round — unlike anything derived from
// getTimezoneOffset(), which would reflect the visitor's zone.
export const PHUKET_UTC_OFFSET_MINUTES = 7 * 60

// A Date → the "YYYY-MM-DDTHH:mm" a datetime-local input expects, read in
// Phuket time. Used for the `min` attribute (now + lead time).
export function toPhuketWallClock(date) {
  return new Date(date.getTime() + PHUKET_UTC_OFFSET_MINUTES * 60000).toISOString().slice(0, 16)
}

// The value of a datetime-local input → an unambiguous instant for the server.
export function phuketPickupAt(value) {
  return value ? `${value}:00+07:00` : null
}

// The date half of a datetime-local value, for the fields that store a plain
// date alongside the pickup instant (BookingRequest#start_on).
export function datePart(value) {
  return value ? String(value).slice(0, 10) : ''
}
